import './header.css';
import logo from '../../assets/images/logo.svg';
import downArrow from '../../assets/images/chevron-bottom-black.svg';
import {NavLink} from "react-router-dom";
const Header = () => {
    const isActive = ({isActive}: any) => isActive ? 'active' : '';

    return(
        <header>
            <div className="content-section flex hr-space-between">
                <div className="logo flex gap-10">
                    <div className="icon logo-icon">
                        <img src={logo} alt=""/>
                    </div>
                    <div className="sf-bold font-16">
                        Onboard Fleet<br/> Services
                    </div>
                </div>

                <nav className={'flex gap-40 grey-color sf-medium font-15'}>
                    <NavLink to={''} className={isActive}>Dashboard</NavLink>
                    <NavLink to={'trips'} className={isActive}>Trips</NavLink>
                    <NavLink to={'liveTrack'} className={isActive}>Live Track</NavLink>
                    <NavLink to={'drivers'} className={isActive}>Drivers</NavLink>
                    {/*<NavLink to={'vehicles'} className={isActive}>Vehicles</NavLink>*/}
                    <NavLink to={'videoTelematics'} className={isActive}>Video  Telematics</NavLink>
                    <a>Reports</a>
                    <a>Settings</a>
                    <div className={'flex gap-20'}>
                        <div className="">John</div>
                        <div className="icon width-12"><img src={downArrow} alt=""/></div>
                    </div>
                </nav>
            </div>
        </header>
    )
}

export default Header;
